/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { literal } from '../util.type';

/**
 * Číselník prostředí sestavené aplikace.
 * @enum {'DEV' | 'PROD'}
 * @readonly
 */
const EnvEnum = {
  /** Prostředí pro vývojáře. */
  DEV: literal('DEV'),
  /** Produkční prostředí. */
  PROD: literal('PROD')
};

export default EnvEnum;
